import '../../../Optics/Dialog/styleDialog.css';
import CustomSnackbar from '../../../Optics/Components/CustomSnackbar';
import React from 'react';

import WifiPointDescription from './WifiPointDescription';

const DescriptionComponentModalWifi = ({ open, onClose, content, markerType,isLineDrawing, fobMarker, wifiPointRefreshById, setIsComponentChangeCoorWifi
    }) => {

        
 
const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

const copyToClipboard = (text, type) => {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  textarea.focus(); 
  try {
    const successful = document.execCommand("copy");
    if (successful) {
      showSnackbar('Скопировано: ' + type + ': ' + text, 'snackbarOk');
    } else {
      showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
    }
  } catch (err) {
    showSnackbar('Не удалось скопировать ID в буфер обмена', 'snackbarError');
  }
  document.body.removeChild(textarea);
};

 
  if (!fobMarker) {
    return (
      <WifiPointDescription
        open={open}
        onClose={onClose}
        content={content}
        snackbarOpen={snackbarOpen}
        snackbarMessage={snackbarMessage}
        snackbarClass={snackbarClass}
        handleCloseSnackbar={handleCloseSnackbar}
        copyToClipboard={copyToClipboard}
        wifiPointRefreshById={wifiPointRefreshById}
        setIsComponentChangeCoorWifi={setIsComponentChangeCoorWifi}
      />
    );
  }
  else {
    return null; 
  }
  }
 
export default DescriptionComponentModalWifi;